"use client";

import { c as _c } from "react/compiler-runtime";
import { createPortal } from "react-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { useImageLightbox } from "./useImageLightbox";
type Props = {
  pictures: string[];
  open: boolean;
  initialIndex: number;
  onClose: () => void;
  manageHistory?: boolean;
};
export default function ImageLightbox(t0) {
  const $ = _c(16);
  const {
    pictures,
    open,
    initialIndex,
    onClose,
    manageHistory
  } = t0;
  let t1;
  if ($[0] !== initialIndex || $[1] !== manageHistory || $[2] !== onClose || $[3] !== open || $[4] !== pictures) {
    t1 = {
      pictures,
      open,
      initialIndex,
      onClose,
      manageHistory
    };
    $[0] = initialIndex;
    $[1] = manageHistory;
    $[2] = onClose;
    $[3] = open;
    $[4] = pictures;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    mounted,
    index,
    total,
    goPrev,
    goNext
  } = useImageLightbox(t1);
  if (!mounted) {
    return null;
  }
  let t2;
  if ($[6] !== goNext || $[7] !== goPrev || $[8] !== index || $[9] !== onClose || $[10] !== open || $[11] !== pictures || $[12] !== total) {
    t2 = open && <motion.div key="lightbox" className="fixed inset-0 z-[100]" style={{
      pointerEvents: "auto"
    }} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onPointerDown={_temp}><div className="absolute inset-0 bg-black/85 backdrop-blur-sm" /><div className="absolute inset-0 flex items-center justify-center pointer-events-none px-20"><AnimatePresence mode="popLayout" initial={false}><motion.img key={index} src={pictures[index]} alt={`Image ${index + 1}`} draggable={false} className="max-w-full max-h-[85vh] rounded-3xl shadow-2xl object-contain select-none" initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.96
          }} transition={{
            type: "spring",
            stiffness: 260,
            damping: 28
          }} /></AnimatePresence></div><button type="button" onClick={e_0 => {
        e_0.stopPropagation();
        onClose();
      }} aria-label="Close" className="absolute top-4 right-4 z-20 flex items-center justify-center w-10 h-10 rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors cursor-pointer"><X className="w-5 h-5" /></button>{total > 1 && <><button type="button" onClick={e_1 => {
          e_1.stopPropagation();
          goPrev();
        }} aria-label="Previous" className="absolute left-4 top-1/2 -translate-y-1/2 z-20 flex items-center justify-center w-12 h-12 rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors cursor-pointer"><ChevronLeft className="w-6 h-6" /></button><button type="button" onClick={e_2 => {
          e_2.stopPropagation();
          goNext();
        }} aria-label="Next" className="absolute right-4 top-1/2 -translate-y-1/2 z-20 flex items-center justify-center w-12 h-12 rounded-full bg-white/15 hover:bg-white/30 text-white transition-colors cursor-pointer"><ChevronRight className="w-6 h-6" /></button><div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur-md text-white/90 text-sm font-medium">{index + 1} / {total}</div></>}</motion.div>;
    $[6] = goNext;
    $[7] = goPrev;
    $[8] = index;
    $[9] = onClose;
    $[10] = open;
    $[11] = pictures;
    $[12] = total;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t2) {
    t3 = createPortal(<AnimatePresence>{t2}</AnimatePresence>, document.body);
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}
function _temp(e) {
  return e.stopPropagation();
}